export const DEFAULT_DASHBOARD_KEY = 'DEFAULT-DASHBOARD';
export const GLOBAL_DASHBOARD_KEY = 'GLOBAL-DASHBOARD';
export const DASHBOARD_ADMINISTRATOR_RIGHTS_CODE = 'GLOBAL_DASHBOARD_MANAGE';
